// @flow
import type {SearchRequest} from '../models/SearchRequest';
import type {Options} from './SearchUrlParser';
import GTSearchUrlParser from './GTSearchUrlParser';

export default class AbritelSearchUrlParser extends GTSearchUrlParser {
    parse(url: string, options: Options = {}): SearchRequest {
        // check if it's a legacy URL. We don't do this client side due to the ginormous data file required to do this.
        if (typeof window === 'undefined') {
            const urlStore = require('../data/abritel_legacy_urls.json');
            const urlParser = require('url');
            const parsedUrl = urlParser.parse(url);
            const pathname =
                parsedUrl.pathname &&
                parsedUrl.pathname
                    .replace(/_dt\d+.php/, '_dt0.php')
                    .replace('%27', "'"); // replace _dt* to support SEO bot requests with non 0 page number
            const queryParams = require('query-string').parse(
                parsedUrl.query || ''
            );

            const searchTermUuid = urlStore[pathname];
            if (searchTermUuid) {
                return {
                    searchTermUuid,
                    ...queryParams
                };
            } else if (
                pathname === '/annonces/location-vacances/monde_dt0.php'
            ) {
                // world search case
                return {
                    regionId: 1, // this is needed for world canonical link
                    ...queryParams
                };
            }
        }

        // default to normal GT logic
        return super.parse(url, options);
    }
}
